module.exports = __webpack_public_path__ + "img/tuev.305fa395.svg";